import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-connection-auth-connected', {
    margin: '0 auto 18px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '12px',
});

cssRule('.tb-connection-auth', {
    position: 'absolute',
    top: '10%',
    right: 0,
    bottom: 0,
    left: 0,
    textAlign: 'center',
});

cssRule('.tb-connection-auth .tb-login-logo', {
    marginBottom: '48px',
});

cssRule('.tb-connection-auth .tb-login-text-box', {
    width: '270px',
});

cssRule('.tb-connection-auth .tb-login-text-box .tb-text-box-border', {
    borderRadius: 0,
    paddingLeft: '1px',
    paddingRight: '1px',
    border: 'none',
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
});

cssRule('.tb-connection-auth .tb-login-text-box .tb-text-box-border:hover', {
    border: 'none',
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.hover, '#666'),
});

cssRule('.tb-connection-auth .tb-login-msg', {
    padding: '18px 18px',
});

cssRule('.tb-connection-auth-prompt', {
    margin: '0 auto 12px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '14px',
});

cssRule('.tb-connection-property', {
    textAlign: 'left',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '120px',
    width: '400px',
});

cssRule('.tb-connection-property-label', {
    display: 'inline-block',
    width: '120px',
    fontWeight: 'bold',
});

cssRule('.tb-connection-auth-error', {
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
});

cssRule('.tb-auth-properties', {
    paddingTop: '35px',
});

